import { Feature } from '../types'

export const Conciseness: Feature = {
  title: 'Conciseness',
  alertName: 'Conciseness',
}

export const Grammar: Feature = {
  title: 'Grammar',
}

export const Punctuation: Feature = {
  title: 'Punctuation',
}

export const Other: Feature = {
  title: 'Additional issues',
}

export const Spelling: Feature = {
  title: 'Spelling',
}

export const Plagiarism: Feature = {
  title: 'Plagiarism detection',
  alertName: 'Originality',
}

export const Readability: Feature = {
  title: 'Readability',
  alertName: 'Clarity',
}

export const WordChoice: Feature = {
  title: 'Word choice',
  alertName: 'Vocabulary',
}
